import {ajaxPost,ajaxGet} from '../config/ajax.js';
import {readMessageList, getUnreadMessageCount, recordVideoTime, getMyMessageList, getMyMessageDetail, queryTestPaperList, queryStudyVideo, 
    getMyMessageListBbgb, getMyMessageDetailBbgb,} from '../address/url.js';

// 通知公告
// 读取通知列表（全部通知,企业）
export const  ReadMessageList  = function(params) {
    return ajaxPost(readMessageList, params)
}
// 通知公告获取未读通知数量
export const  GetUnreadMessageCount  = function(params) {
    return ajaxPost(getUnreadMessageCount, params)
}
// 视频音频播放进度
export const  RecordVideoTime  = function(params) {
    return ajaxPost(recordVideoTime, params)
}
// 我的消息列表
export const  GetMyMessageList  = function(params) {
    return ajaxPost(getMyMessageList, params)
}
// 我的消息详情
export const GetMyMessageDetail  = function(params) {
    return ajaxGet(getMyMessageDetail + '?' + params)
}
// 考题列表
export const  QueryTestPaperList  = function(params) {
    return ajaxPost(queryTestPaperList, params)
}
// 考题培训视频列表
export const  QueryStudyVideo  = function(params) {
    return ajaxPost(queryStudyVideo, params)
}
// 包保干部角色 我的消息列表
export const  GetMyMessageListBbgb  = function(params) {
    return ajaxPost(getMyMessageListBbgb, params)
}
// 包保干部角色 我的消息详情
export const GetMyMessageDetailBbgb  = function(params) {
    return ajaxGet(getMyMessageDetailBbgb + '?' + params)
}


// WEBPACK FOOTER //
// ./src/js/noticeQy/noticeQy.js